const getAllCollectionsForLocale = async (graphql, locale) => {
  const { data } = await graphql(`
    fragment internalLinkFields on LinkValue {
      ... on SanityPage {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanitySharedPage {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanityBlogPost {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanityBlogCategory {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanityPressRelease {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanityPerson {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanityGlobalProduct {
        id: _id
        _type
        store {
          slug {
            current
          }
        }
      }
      ... on SanityGlobalProductCollection {
        id: _id
        _type
        store {
          title
          slug {
            current
          }
        }
      }
    }
    query SanityHeaderQuery {
      allCollections: allSanityGlobalProductCollection(
        filter: {
          siteIdentifier: { eq: "petsafe" }
          products: { elemMatch: { store: { status: { eq: "active" } } } }
          language: { eq: "${locale}"}
        }
      ) {
        nodes {
          products {
            _id
          }
          store {
            title
          }
          _id
          language
          navMoment {
            headline
            image {
              alt
              asset {
                _id
                url
              }
              hotspot {
                x
                y
              }
            }
            link {
              linkType
              href
              blank
              internalLink: localizedInternalLinkValue(locale: "${locale}") {
                ...internalLinkFields
              }
            }
          }
          navChildCollectionsOrder {
            store {
              title
            }
          }
        }
      }
    }
  `);

  const allCollections = data.allCollections.nodes;
  return allCollections;
};

const getAllCollections = async (graphql, languages) => {
  const allCollections = await Promise.all(
    languages.map(async l => ({
      locale: l.id,
      collections: await getAllCollectionsForLocale(graphql, l.id),
    }))
  );

  return allCollections.reduce((acc, curr) => {
    acc[curr.locale] = curr.collections;
    return acc;
  }, {});
};

module.exports = {
  getAllCollections,
};
